import { useDispatch, useSelector } from 'react-redux'
import { HeaderAdmin } from '../HeaderAdmin'
import * as S from './styles'
import { AppDispatch } from '../../../App'
import { AsideAdmin } from '../AsideAdmin'
import { Button, Col, Dropdown, Form, Input, Menu, Modal, Row } from 'antd'
import { getMateriais as getMateriaisSelector } from '../../../shared/redux/selectors'
import { Material as MaterialDictionary } from '../../../shared/utils/dictionary'
import { getMateriais } from '../../../shared/redux/slices/loja'
import { useEffect, useState } from 'react'
import { deleteMaterial, editMaterial, postMaterial } from '../../../service/apiAdmin'
import { toast } from 'react-toastify'

export const Material = () => {
    const dispatch = useDispatch<AppDispatch>()
    const material = useSelector(getMateriaisSelector)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalEditarOpen, setIsModalEditarOpen] = useState(false);
    const [editObj, setEditObj] = useState<any>(null);
    const [form] = Form.useForm();

    useEffect(() => {
        dispatch(getMateriais())
    },[])

        const menuItems: any = [
        {
          key: 'editar',
          label: (
              <span style={{display: "flex", alignItems: "center", gap: 10}}>
                <i className="ri-pencil-line"></i>
                <b>Editar</b>
              </span>
          ),
        },
        {
          key: 'deletar',
          label: (
            <span style={{display: "flex", alignItems: "center", gap: 10}}>
              <i style={{color: "red"}} className="ri-delete-bin-6-line"></i>
              <b>Deletar</b>
            </span>
        ),
          danger: true,
        },
      ];
    
      const handleCancel = () => {
        if(isModalEditarOpen) {
            window.location.reload()
        }
          form.resetFields();
        setIsModalOpen(false);
        setIsModalEditarOpen(false);
      };

      const onFinish = async (values: any) => {
        const data = {
            nome: values.nome,
            texto: ""
        }
        if(isModalEditarOpen) {
            try {
                await editMaterial(data, editObj[MaterialDictionary.ID])
                form.resetFields();
                setIsModalOpen(false)
                setIsModalEditarOpen(false)
                window.location.reload()
            } catch {
                toast.error("Ocorreu um erro ao criar material, tente novamente mais tarde ou entre em contato com nosso suporte.")
            }
        } else {
            try {
                await postMaterial(data)
                window.location.reload()
                form.resetFields();
                setIsModalOpen(false)
            } catch {
                toast.error("Ocorreu um erro ao criar material, tente novamente mais tarde ou entre em contato com nosso suporte.")
            }
        }
      };

      useEffect(() => {
        if (isModalEditarOpen && editObj) {
          form.setFieldsValue({
            nome: editObj[MaterialDictionary.NOME]
          });
        } else {
          form.resetFields();
        }
      }, [isModalEditarOpen, editObj, form]);

    return (
        <S.Container>
            <Modal style={{overflow: "hidden"}} key={isModalEditarOpen ? editObj?.id : 'create'} title="Cadastrar Material" footer={null} open={isModalOpen} onCancel={handleCancel}>
            <Form
                form={form}
                name="material"
                initialValues={isModalEditarOpen ? {nome: editObj?.[MaterialDictionary.NOME]} : undefined}
                onFinish={onFinish}
                autoComplete="off"
            >
                <Form.Item
                label="Nome"
                name="nome"
                rules={[{ required: true, message: 'Por favor insira o material!' }]}
                >
                <Input />
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 20, span: 20 }}>
                <Button type="primary" htmlType="submit">
                    Enviar
                </Button>
                </Form.Item>
            </Form>
            </Modal>
                    <AsideAdmin />
                    <HeaderAdmin />
                    <div className='title-container'>
                        <div className='title'>
                            <i className="ri-bubble-chart-line ri-3x"></i>
                            <h1>Materiais</h1>
                        </div>
                        <Button onClick={() => {
                            setIsModalOpen(true)
                            setIsModalEditarOpen(false)
                        }} type='primary'>Cadastrar novo material</Button>
                    </div>

                    <div>
                 <Row className='title-table'>
                     <Col span={9}>
                         <h4>Nome</h4>
                     </Col>
                     <Col span={1}>
                         <h4>Ações</h4>
                     </Col>
                 </Row>
                 {material?.map((x) => (
                <Row key={x[MaterialDictionary.ID]} className='title-table'>
                    <Col span={9}>
                        <h5>{x[MaterialDictionary.NOME]}</h5>
                    </Col>
                    <Col className='actions' span={1}>
                    <Dropdown placement="bottomLeft" overlay={
                        <Menu>
                            {menuItems.map((item: any) => (
                            <Menu.Item onClick={async () => {
                                const edit = material.find(m => m[MaterialDictionary.ID] === x[MaterialDictionary.ID])

                                if(item?.danger) {
                                    try {
                                        await deleteMaterial(x[MaterialDictionary.ID].toString())
                                        dispatch(getMateriais())
                                    } catch {
                                        toast.error(`Ocorreu um erro ao deletar material ${x[MaterialDictionary.NOME]}`)
                                    }
                                    dispatch(getMateriais())
                                } else {
                                    setEditObj(edit)
                                    setIsModalEditarOpen(true);
                                    setIsModalOpen(true)
                                }
                            }} key={item?.key} danger={item?.danger}>
                                {item.icon} {item.label}
                            </Menu.Item>
                            ))}
                        </Menu>
                        }>
                        <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                            <i style={{color: "black"}} className="ri-file-list-line ri-lg"></i>
                        </a>
                        </Dropdown>
                    </Col>
                </Row>
                ))}
            </div>
        </S.Container>
    )
}